import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { toggleBreadcrumbs } from 'Store/Breadcrumbs/Breadcrumbs.action';
import { updateMeta } from 'Store/Meta/Meta.action';
import { changeNavigationState } from 'Store/Navigation/Navigation.action';
import { showNotification } from 'Store/Notification/Notification.action';
import { isSignedIn } from 'Util/Auth';
import BrowserDatabase from 'Util/BrowserDatabase';
import GiftCardPage from './GiftCardPage.component';
import { fetchQuery } from 'Util/Request';
import CartQuery from 'Query/Cart.query';

import { TOP_NAVIGATION_TYPE } from 'Store/Navigation/Navigation.reducer';
import { CMS_PAGE } from 'Component/Header/Header.config';
import { GUEST_QUOTE_ID } from 'SourceStore/Cart/Cart.dispatcher';

const CartDispatcher = import(/* webpackMode: "lazy", webpackChunkName: "dispatchers" */'Store/Cart/Cart.dispatcher');

export const mapStateToProps = (state) => ({
    quote_currency_code: state.CartReducer.cartTotals.quote_currency_code
});

export const mapDispatchToProps = dispatch => ({
    addGiftCard: (input, quoteId) => CartDispatcher.then(
        ({ default: dispatcher }) => dispatcher.addGiftCardToCart(dispatch, input, quoteId)
    ),
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    toggleBreadcrumbs: state => dispatch(toggleBreadcrumbs(state)),
    updateMeta: meta => dispatch(updateMeta(meta)),
    setHeaderState: stateName => dispatch(changeNavigationState(TOP_NAVIGATION_TYPE, stateName)),
});

export class GiftCardPageContainer extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            card_input: '',
            card_terms: '',
            loading: true,
            isLoading: false
        }
    }

    containerFunctions = ({
        onStepClick: this.onStepClick.bind(this),
        onCustomStepChange: this.onCustomStepChange.bind(this),
        onCustomStepKeyPress: this.onCustomStepKeyPress.bind(this),
        onFormSubmitSuccess: this.onFormSubmitSuccess.bind(this),
        onTermsClick: this.onTermsClick.bind(this)
    });

    containerProps = () => {
        const {
            title,
            short_description,
            image,
            description,
            card_step,
            card_value,
            card_input,
            card_terms,
            isLoading,
            loading
        } = this.state

        const { quote_currency_code } = this.props;

        return {
            title,
            short_description,
            image,
            description,
            card_step,
            card_value,
            card_input,
            card_terms,
            quote_currency_code,
            isLoading,
            loading
        };
    };

    componentDidMount() {
        const { toggleBreadcrumbs, setHeaderState, updateMeta } = this.props;

        toggleBreadcrumbs(false);

        setHeaderState({
            name: CMS_PAGE,
            title: __('Gift card'),
            onBackClick: () => history.goBack()
        });

        updateMeta({ title: __('Gift card') });

        fetchQuery(CartQuery.getGiftCardProduct()).then(
            ({ getGiftCardProduct }) => {
                const card_step = getGiftCardProduct.amounts.map(amount => amount.value);
                const image = getGiftCardProduct.image.url;

                this.setState({
                    ...getGiftCardProduct,
                    card_step,
                    card_value: getGiftCardProduct.amounts[0].value,
                    image,
                    loading: false
                })
            },
            (error) => console.log(error)
        );
    }

    onFormSubmitSuccess(fields) {
        const { card_value, card_step, sku } = this.state;
        const { addGiftCard, showNotification } = this.props;

        const {
            recipient_name,
            recipient_email,
            sender_name,
            message
        } = fields;

        if (card_value < 50 || card_value > 999) {
            showNotification('info', __('The value of the gift card must not be between 50 - 999 €'));

            return;
        }

        const quoteId = !isSignedIn() && BrowserDatabase.getItem(GUEST_QUOTE_ID);

        const input = {
            sku,
            guestCartId: quoteId,
            am_giftcard_sender_name: sender_name,
            am_giftcard_recipient_name: recipient_name,
            am_giftcard_recipient_email: recipient_email,
            am_giftcard_message: message,
            qty: 1,
            ...( card_step.includes(card_value) ? { am_giftcard_amount: card_value } : { am_giftcard_amount_custom: card_value } )
        }

        this.setState({ isLoading: true })
        addGiftCard(input, quoteId)
            .then(
                () => this.afterAddGiftCardToCart(),
                () => this.setState({isLoading: false })
            );
    }

    afterAddGiftCardToCart() {
        const { showNotification } = this.props;

        showNotification('success', __('Gift Card added to cart'));
        this.setState({isLoading: false })
    }

    onStepClick(step) {
        this.setState({
            card_value: step,
            card_input: ''
        })
    }
    onCustomStepKeyPress(e) {
        if ("0123456789".indexOf(String.fromCharCode(e.which)) == -1) {
            e.preventDefault();
        }

        return;
    }
    onCustomStepChange(e) {
        const input_value = e.target.value || 0
        this.setState({
            card_value: input_value || 0,
            card_input: input_value
        })
    }

    onTermsClick() {
        this.setState((prevState) => ({ card_terms: prevState.card_terms ? '' : true }));
    }

    render() {
        return (
            <GiftCardPage
                { ...this.containerFunctions }
                { ...this.containerProps() }
            />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftCardPageContainer);
